import React, { useState } from 'react'
import ContactUs from '../sections/home/Contactus'
import Banner from '../sections/home/Banner'
import PopularCategories from '../sections/home/PopularCategories'
import Events from '../sections/home/Events'
import Precision from '../sections/home/Precision'
import Blogs from '../sections/home/Blogs'
import About from '../sections/home/About'



function PrivateHome({ }) {

    return (
        <div>
            <Banner />
            <Events />
            <Precision />
            <Blogs />
            <About />
            <ContactUs />
        </div>
    )
}

export default PrivateHome;
